export default {
  lucky: {
    prizeAgain: 'دوبارہ گھمائیں',
    prizeThanks: 'اگلی بار قسمت آزمائیں',
    remainingChance: 'باقی موقعے',
    task: 'ٹاسک',
    deposit: 'جمع',
    wager: 'شرط',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'کارڈ کلیکشن',
    puzzleRound: 'راؤنڈ {current}/{total}',
    puzzleReward: 'مکمل کرنے کا انعام {amount}',
    redeem: 'ریڈیم کریں',
    redeemSuccess: 'کامیابی سے ریڈیم ہو گیا',
    redeemSuccessWithReward: 'کامیابی سے ریڈیم ہو گیا! آپ کو {amount} {currency} ملا',
    redeemFailed: 'ریڈیم ناکام',
    notComplete: 'ابھی مکمل نہیں ہوا، ریڈیم نہیں ہو سکتا',
    drawFailed: 'ڈرا ناکام، براہ کرم دوبارہ کوشش کریں',
    gainLetter: 'مبارک ہو! آپ کو حرف {letter} ملا',
    gainBlock: 'مبارک ہو! آپ کو تصویر {blockNo} ملی',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'دعوت دیں',
    claimReward: 'حاصل کریں',
    noChest: 'کوئی صندوق نہیں',
    claimSuccess: '{count} صندوق حاصل کیے، {amount} {currency}',
    modalTitle: 'خزانے کا صندوق',
    modalSubtitle: 'سب دیکھنے کے لیے سوائپ کریں',
    chipTodayClaimed: 'آج وصول کیے',
    chipClaimable: 'قابل وصول',
    chipLocked: 'لاک',
    totalClaimedCount: 'وصول شدہ صندوق کی تعداد',
    totalClaimedAmount: 'کل وصول شدہ رقم',
    chestUnit: 'عدد',
    claimAll: 'سب وصول کریں',
    goInvite: 'دوستوں کو دعوت دیں',
    claimSingleSuccess: '{amount} {currency} وصول کیا',
    labelClaimed: 'وصول شدہ',
    labelClaimable: 'قابل وصول',
    labelLocked: 'لاک',
  },
}
